module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1141"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1141"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.29009",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};